module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "total"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-question sicon one"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("点击人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText one"
  }, [_vm._v(_vm._s(_vm.c2data.total.click_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-success sicon two"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("成功人数")]), _vm._v(" "), _c('div', {
    staticClass: "numText two"
  }, [_vm._v(_vm._s(_vm.c2data.total.clickok_uv || '0'))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-news sicon three"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("跳出率")]), _vm._v(" "), _c('div', {
    staticClass: "numText three"
  }, [_vm._v(_vm._s(_vm.c2data.total.jump_per || '0') + "%")])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets sicon four"
  }), _vm._v(" "), _c('span', {
    staticClass: "tjContent"
  }, [_c('div', [_vm._v("收入预估")]), _vm._v(" "), _c('div', {
    staticClass: "numText four"
  }, [_vm._v(_vm._s(_vm.c2data.total.income || '0'))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "seven",
      "autofocus": "",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "150px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.toogleChart
    }
  }, [_vm._v("图表")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "dropdown",
    on: {
      "command": _vm.themeFilter
    }
  }, [_c('el-button', {
    staticClass: "dropdown",
    attrs: {
      "type": "normal"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tText) + "\n                "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": ""
    }
  }, [_vm._v("所有类型")]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "command": i
      }
    }, [_vm._v(_vm._s(v[0]))])
  })], 2)], 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入发行游戏名称",
      "suffix-icon": _vm.pdata.issued_app_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.issued_app_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_name", $$v)
      },
      expression: "pdata.issued_app_name "
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search",
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入创意名称",
      "suffix-icon": _vm.pdata.creative_name.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.creative_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "creative_name", $$v)
      },
      expression: "pdata.creative_name "
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), _c('el-table', {
    staticClass: "data",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.c2data.list,
      "row-key": "keyid",
      "stripe": "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "expand-change": _vm.expands
    }
  }, [(_vm.dateVal[0] !== _vm.dateVal[1]) ? _c('el-table-column', {
    attrs: {
      "type": "expand",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('el-table', {
          attrs: {
            "data": s.row.exData,
            "show-header": false,
            "row-key": "keyid"
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "d_date",
            "label": "时间",
            "align": "center",
            "width": "150px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "aname",
            "label": "发行游戏名称",
            "width": "180px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "pname",
            "label": "发行游戏创意名称",
            "width": "180px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "ctype",
            "label": "创意类型"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_uv",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_uv",
            "align": "center",
            "width": "180px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "clickok_per",
            "label": "创意点击率",
            "width": "180px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.clickok_per != 0) ? _c('span', [_vm._v("\n\t\t\t\t\t\t      \t\t\t" + _vm._s((scope.row.clickok_per) + '%') + "\n\t\t\t\t\t\t      \t")]) : _c('span', [_vm._v("\n\t\t\t\t\t\t      \t\t--\n\t\t\t\t\t\t      \t")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "ecmp",
            "sortable": "",
            "sort-method": function (a, b) {
              return (a.ecmp - 0) - (b.ecmp - 0)
            },
            "label": "ecmp",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "income",
            "label": "收入预估",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jump_per",
            "label": "跳出率",
            "align": "center"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "click_price",
            "label": "点击单价",
            "align": "center"
          }
        })], 1)]
      }
    }], null, false, 3445292149)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_id",
      "label": "ID",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "发行游戏名称",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "发行游戏创意名称",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ctype",
      "label": "创意类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.click_uv - 0) - (b.click_uv - 0)
      },
      "label": "创意点击数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.clickok_uv - 0) - (b.clickok_uv - 0)
      },
      "label": "创意点击确定数",
      "width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clickok_uv",
      "label": "创意点击率",
      "width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.click_uv * 100 != 0) ? _c('span', [_vm._v("\n      \t\t\t" + _vm._s((scope.row.clickok_uv / scope.row.click_uv * 100).toFixed(2) + '%') + "\n      \t")]) : _c('span', [_vm._v("\n      \t\t--\n      \t")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ecmp",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.ecmp - 0) - (b.ecmp - 0)
      },
      "label": "ecmp",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "收入预估",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.income - 0) - (b.income - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jump_per",
      "label": "跳出率",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.jump_per - 0) - (b.jump_per - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n      \t\t" + _vm._s(scope.row.jump_per + '%') + "\n        \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_price",
      "label": "点击单价",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a1919b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adData/cData.vue
// module id = 1100
// module chunks = 2